import { MenuItem, Select, styled, Typography } from '@mui/material';

export const ListW = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 16px;
  align-items: start;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    margin-top: 0px;
  }
`;

export const SortBarW = styled('div')`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
    margin-top: 0px;
    margin-bottom: 8px;
  }
`;

export const SortSelect = styled(Select)`
  font-size: 14px;
  border-radius: 8px;
  padding: 4px;
  background: ${({ theme }) => theme.palette.background.paper};

  & .MuiSelect-select {
    padding: 8px 14px;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: 1px solid #ddd;
  }

  &:hover .MuiOutlinedInput-notchedOutline {
    border: 1px solid #ddd;
  }

  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid #ddd;
  }
`;

export const SortMenuItem = styled(MenuItem)`
  margin: 4px 8px;
  &&:hover {
    background-color: ${({ theme }) => theme.palette.info.light};
  }

  &&.Mui-selected {
    background-color: ${({ theme }) => theme.palette.info.p020};
  }

  &&.Mui-selected:hover {
    background-color: ${({ theme }) => theme.palette.info.p030};
  }
`;

export const CommentsLabelW = styled(Typography)`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-top: 16px;
  margin-bottom: 8px;
`;
